/*@flow*/
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import styled from '@emotion/styled';
import {
  LEVEL,
  PAGE_NAV_HEIGHT,
  BREAKPOINT_MD,
  BREAKPOINT_MD_MAP_HEIGHT,
} from 'store/constants';
import { hot } from 'react-hot-loader';
import slug from 'lib/slug';
import { useState, createRef, memo } from 'react';
import ClickOutside from 'comps/App/ClickOutside';
import getUrl from 'lib/getUrl';

const UrlField = memo(props => {
  if (!props.show) return null;
  const ref = createRef();
  return (
    <div
      css={css(`
      cursor: pointer;
      border: solid 1px #ccc;
      border-radius: 5px;

      position: absolute;
      right: 0;
      top: 2.4rem;
      width: 300px;

      font-size: 1rem;
      height: 1.7rem;
      line-height: 1rem;

      display: grid;
      grid-template-columns: 40px 1fr;

    `)}
      onClick={e => {
        if (ref.current) {
          ref.current.select();
        }
      }}
    >
      <b
        css={css(`
          padding: 6px 0 0 0px;
          background: #999;
          color: white;
          font-size: 0.825rem;
          text-align: center;
      `)}
      >
        <i className="fa fa-link" />
      </b>
      <input
        ref={ref}
        css={css(`
          cursor: pointer;
          line-height: 1.3rem;
          padding: 4px 4px 0;
          display: grid;
          align-items: center;

          // &:hover {
          //   background: #efefef;
          // }
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
      `)}
        defaultValue={getUrl()}
      />
      <Triangle
        tSize={10}
        styles={`

        position: absolute;
        top: -20px;
        right: 40px;
      `}
      />
    </div>
  );
});

const Triangle = styled.div(
  props => `
  border-top: ${props.tSize}px solid transparent;
  border-left: ${props.tSize}px solid transparent;
  border-bottom: ${props.tSize}px solid var(--gray);
  border-right: ${props.tSize}px solid transparent;
  background: transparent;
  height: 0;
  width: 0;

  ${props.styles}
`
);

const ShareButton = props => {
  const [isOpen, setOpen] = useState(false);
  if (props.anchor === 'credits') return null;
  return (
    <div
      css={css(`
      margin-left: auto;
      position: relative;
      cursor: pointer;
    `)}
    >
      <div
        css={css(`
          line-height: 1.4rem;
          display: grid;
          align-items: center;
          background: none;
          border: none;
        `)}
        onClick={() => {
          setOpen(!isOpen);
        }}
      >
        <span>
          Share <i className="fa fa-share-alt" />
        </span>
      </div>
      <ClickOutside onClickOutside={() => setOpen(false)}>
        <UrlField show={isOpen} />
      </ClickOutside>
    </div>
  );
};

const Component = (props: { title: string, styles?: string }) => {
  const id = slug(props.title);

  return (
    <div
      id={id}
      className="CellHeader sticky"
      css={css(`
        position: sticky;
        top: ${PAGE_NAV_HEIGHT.toString()};
        @media (max-width: ${BREAKPOINT_MD.toString()}) {
          top: ${BREAKPOINT_MD_MAP_HEIGHT.toString()};
          overflow: hidden;
        }
        background: var(--brand-white);
        color: var(--brand-black);
        border-bottom: solid 1px #efefef;

        z-index: ${LEVEL.PAGE_NAV - 1};
        padding-left: 1rem;
        padding-right: 1rem;
        padding-top: 10px;
        display: grid;
        align-items: center;
        ${props.styles || ''}
      `)}
    >
      <div
        css={css(
          `
          font-weight: normal;
          color: var(--gray);
          display: flex;
          padding: 0;
          font-size: 1.4rem;
          line-height: 2rem;
        `
        )}
        className="Title"
      >
        {props.title} <ShareButton anchor={id} />
      </div>
    </div>
  );
};

export default hot(module)(Component);
